import {
  DASHBOARD_INITIALIZE_SUCCESS,
  DASHBOARD_SHOW_ONBOARDING_DIALOG,
  DASHBOARD_CLOSE_ONBOARDING_DIALOG,
} from './constants';

const initialState = {
  isFetching: true,
  showOnboardingDialog: false,
};

export function dashboard(state = initialState, { type, payload }) {
  switch (type) {
    case DASHBOARD_INITIALIZE_SUCCESS: {
      return Object.assign({}, state, { isFetching: false });
    }
    case DASHBOARD_SHOW_ONBOARDING_DIALOG: {
      return Object.assign({}, state, { showOnboardingDialog: true });
    }
    case DASHBOARD_CLOSE_ONBOARDING_DIALOG: {
      return Object.assign({}, state, { showOnboardingDialog: false });
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/dashboard/reducer.js